<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
        reqisfinish: false, //请求是否完成
        timer: null,
        index: 0,
        iserror: false, //接口是否报错
    }
  },
  methods: {
      setIntervalfuc() {
          this.timer = setInterval(() => {
            console.log('定时器')
              this.index ++;
              if (this.index > 10) {
                  this.index = 0;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.setIntervalfuc();
              }
              let token = localStorage.getItem('token');
              let user = localStorage.getItem('user')
              if (token && user && !this.reqisfinish) {
                  let id = JSON.parse(user).memberInfo.id;
                  this.reqisfinish = true;
                  this.axios.get('osapi/member/checkloginStatus',{
                      params: {
                        id: id
                      }
                    }).then( res => {
                      this.iserror = false;
                      let { code , msg } = res.data;
                      if (code == 800) {
                          localStorage.clear();
                          this.reqisfinish = false;
                          this.$alert(msg, '提示', {
                              confirmButtonText: '重新登录',
                              showClose: false,
                              callback: action => {
                                location.href = '/Login'
                              }
                          });
                      } else if (code == 0) {
                          this.$message({
                              type: 'info',
                              message: msg
                          })
                          this.reqisfinish = false;
                      } else if (code == 1) {
                          this.reqisfinish = false;
                      }
                  }).catch( err => {
                    console.log('报错了~~~~~~~~~~~~~~~~')
                    if (!this.iserror) {
                      this.$message({
                        type: 'error',
                        message: '服务器繁忙，请稍后再试！'
                      })
                    }
                    this.iserror = true;
                    this.reqisfinish = false;
                  })
              }

          },2000)
      }
  },
  mounted() {
      //this.setIntervalfuc()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue